import { render, staticRenderFns } from "./AgentProfileTabs.vue?vue&type=template&id=3530b126&scoped=true"
import script from "./AgentProfileTabs.vue?vue&type=script&lang=js"
export * from "./AgentProfileTabs.vue?vue&type=script&lang=js"
import style0 from "./AgentProfileTabs.vue?vue&type=style&index=0&id=3530b126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530b126",
  null
  
)

export default component.exports